import { createSlice } from "@reduxjs/toolkit";

import { ICategoryStore } from "../types";

const initialState: ICategoryStore = {
  categories: [],
};

export const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setCategories: (state, { payload }) => {
      state.categories = payload;
    },
  },
});

export const { setCategories } = categorySlice.actions;
